export const BACKUP_PLAN_DATABASE_CREATED = "s0135";
export const BACKUP_PLAN_DATABASE_CREATE_ERROR = "e0135";
export const BACKUP_PLAN_DATABASE_UPDATED = "s0136";
export const BACKUP_PLAN_DATABASE_UPDATE_ERROR = "e0136";
export const BACKUP_PLAN_DATABASE_TURNED_ON = "s0137";
export const BACKUP_PLAN_DATABASE_TURN_ON_ERROR = "e0137";
export const BACKUP_PLAN_DATABASE_TURNED_OFF = "s0138";
export const BACKUP_PLAN_DATABASE_TURN_OFF_ERROR = "e0138";

export const BACKUP_DATABASE_CREATED = "s0155";
export const BACKUP_DATABASE_CREATE_ERROR = "e0155";
export const BACKUP_DATABASE_UPDATED = "s0156";
export const BACKUP_DATABASE_UPDATE_ERROR = "e0156";
export const BACKUP_DATABASE_TURNED_ON = "s0157";
export const BACKUP_DATABASE_TURN_ON_ERROR = "e0157";
export const BACKUP_DATABASE_TURNED_OFF = "s0158";
export const BACKUP_DATABASE_TURN_OFF_ERROR = "e0158";
export const BACKUP_DATABASE_REMOVED = "s0159";
export const BACKUP_DATABASE_REMOVE_ERROR = "e0159";

export const backupPlanDatabase = {
    [BACKUP_PLAN_DATABASE_CREATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_DATABASE_UPDATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_DATABASE_TURNED_ON]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_DATABASE_TURNED_OFF]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_DATABASE_CREATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_DATABASE_UPDATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_DATABASE_TURN_ON_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_DATABASE_TURN_OFF_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.database.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_plan_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    }
};

export const backupDatabase = {
    [BACKUP_DATABASE_CREATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_DATABASE_UPDATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_DATABASE_REMOVED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_DATABASE_TURNED_ON]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_DATABASE_TURNED_OFF]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_DATABASE_CREATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_DATABASE_UPDATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_DATABASE_TURN_ON_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_DATABASE_TURN_OFF_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_DATABASE_REMOVE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.database.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_database.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.backup_database"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_database")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    }
}; 